"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DCMV2 = void 0;
const trade_utils_lib_1 = require("trade_utils_lib");
const operators_1 = require("rxjs/operators");
const interface_1 = require("./interface");
const Interfaces_1 = require("../DualCoinMgrAPI/Interfaces");
class DCMV2Class {
    constructor(apiKey) {
        this.apiKey = apiKey;
    }
    getRequest(url, params) {
        const token = {
            market: this.apiKey.exchange,
            cloudKeyId: this.apiKey.key_id,
        };
        return trade_utils_lib_1.ObservableUtils.getWithAccessAndSpotAuth(url, token, params);
    }
    postRequest(url, params) {
        const token = {
            market: this.apiKey.exchange,
            cloudKeyId: this.apiKey.key_id,
        };
        return trade_utils_lib_1.ObservableUtils.postWithAccessAndSpotAuth(url, token, params);
    }
    deleteRequest(url, params) {
        const token = {
            market: this.apiKey.exchange,
            cloudKeyId: this.apiKey.key_id,
        };
        return trade_utils_lib_1.ObservableUtils.deleteWithAccessAndSpotAuth(url, token, params);
    }
    parseDualOrder(b) {
        let profit_cos_ratio = "";
        if (b.dual_type === Interfaces_1.DualCoinType.base) {
            if (new trade_utils_lib_1.SafeDecimal(b.base_profit).equals(0)) {
                profit_cos_ratio = "0";
            }
            else {
                profit_cos_ratio = new trade_utils_lib_1.SafeDecimal(b.base_settle_ratio).div(new trade_utils_lib_1.SafeDecimal(b.base_profit)).toString();
            }
        }
        else {
            if (new trade_utils_lib_1.SafeDecimal(b.base_profit).equals(0)) {
                profit_cos_ratio = "0";
            }
            else {
                profit_cos_ratio = new trade_utils_lib_1.SafeDecimal(b.currency_settle_ratio).div(new trade_utils_lib_1.SafeDecimal(b.base_profit)).toString();
            }
        }
        return Object.assign(Object.assign({}, b), { profit_cos_ratio: profit_cos_ratio });
    }
    parseStructureDualOrder(b) {
        if (b.actual_type === interface_1.DualStructureOrderType.dual_manual) {
            let profit_cos_ratio = "";
            const dauldata = b.data;
            if (dauldata.dual_type === Interfaces_1.DualCoinType.base) {
                if (new trade_utils_lib_1.SafeDecimal(dauldata.base_profit).equals(0)) {
                    profit_cos_ratio = "0";
                }
                else {
                    profit_cos_ratio = new trade_utils_lib_1.SafeDecimal(dauldata.base_settle_ratio).div(new trade_utils_lib_1.SafeDecimal(dauldata.base_profit)).toString();
                }
            }
            else {
                if (new trade_utils_lib_1.SafeDecimal(dauldata.base_profit).equals(0)) {
                    profit_cos_ratio = "0";
                }
                else {
                    profit_cos_ratio = new trade_utils_lib_1.SafeDecimal(dauldata.currency_settle_ratio)
                        .div(new trade_utils_lib_1.SafeDecimal(dauldata.base_profit))
                        .toString();
                }
            }
            return Object.assign(Object.assign({}, b), { data: Object.assign(Object.assign({}, b.data), { profit_cos_ratio: profit_cos_ratio }) });
        }
        else {
            return b;
        }
    }
    static filterProduct(value) {
        var _a, _b, _c, _d;
        const product = Object.assign({}, value);
        const currentTime = new Date().getTime();
        const deadlineDay = (product.expire_time - currentTime) / 86400000;
        let annualizedValue = new trade_utils_lib_1.SafeDecimal(product.base_profit).mul(product.profit_cos_ratio).div(deadlineDay).mul(365);
        product.origin_profit_cos_ratio = product.profit_cos_ratio;
        if (((_a = value.extra) === null || _a === void 0 ? void 0 : _a.activity_type) === interface_1.DCMActivityType.user_first && ((_b = value.extra) === null || _b === void 0 ? void 0 : _b.extra_profit_mul) !== undefined) {
            annualizedValue = annualizedValue.mul(new trade_utils_lib_1.SafeDecimal((_c = value.extra) === null || _c === void 0 ? void 0 : _c.extra_profit_mul));
            product.profit_cos_ratio = new trade_utils_lib_1.SafeDecimal(product.profit_cos_ratio)
                .mul(new trade_utils_lib_1.SafeDecimal((_d = value.extra) === null || _d === void 0 ? void 0 : _d.extra_profit_mul))
                .toString();
        }
        product.annualizedRate = annualizedValue.toDecimalPlaces(5).toString();
        product.annualized = trade_utils_lib_1.NumberCommonUtils.toPercent(annualizedValue.mul(100), true, true, 3);
        return product;
    }
    filterProducts(data) {
        var _a;
        return ((_a = data.products) !== null && _a !== void 0 ? _a : []).map((e) => {
            return DCMV2Class.filterProduct(e);
        });
    }
    // 写方法
    /**
     * 请求止盈宝产品列表接口
     */
    queryTakeProfitProducts() {
        const url = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().FM_HOST + "/dual/static/group/";
        return this.getRequest(url).pipe((0, operators_1.map)((data) => {
            var _a;
            return ((_a = data.groups) !== null && _a !== void 0 ? _a : []).map((item) => {
                var _a;
                if ((_a = item.smart_list) === null || _a === void 0 ? void 0 : _a.length) {
                    const tempList = item.smart_list.map((e) => {
                        return DCMV2Class.filterProduct(e);
                    });
                    item.smart_list = tempList;
                }
                return item;
            });
        }));
    }
    /**
     * 已申购列表
     * @param param
     */
    queryInvestRecordsV2(param) {
        const url = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().FM_HOST + "/dual/invest/records/";
        return this.getRequest(url, param).pipe((0, operators_1.map)((a) => {
            return {
                has_more: a.has_more,
                records: a.records.map((b) => {
                    return this.parseDualOrder(b);
                }),
            };
        }));
    }
    // 请求产品列表
    queryProductsV2(param) {
        const url = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().FM_HOST + "/dual/products/";
        return this.getRequest(url, param).pipe((0, operators_1.map)((data) => {
            return this.filterProducts(data);
        }));
    }
    //查询产品报价
    queryProductPrice(param) {
        const url = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().FM_HOST + "/dual/prices/";
        return this.getRequest(url, param).pipe((0, operators_1.map)((data) => {
            return data.products;
        }));
    }
    /**
     * 申购产品接口：
     * 会校验买一价base_profit， 用户收益率profit_cosratio和amount是否符合预期，
     * 可能下单节点，买一价和申购额已经不符合预期，会报错，
     * profit_cosratio同样，但是变动概率极小
     */
    invest(params) {
        const url = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().FM_HOST + "/dual/invest/";
        return this.postRequest(url, JSON.stringify(params));
    }
    /**
     * 查询申购状态
     * @param params
     */
    queryInvestInfo(params) {
        const url = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().FM_HOST + "/dual/invest/";
        return this.getRequest(url, params).pipe((0, operators_1.map)((b) => {
            return this.parseDualOrder(b);
        }));
    }
    /**
     * 撤销申购
     * @param params
     */
    revocationInvest(params) {
        const url = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().FM_HOST + "/dual/invest/";
        return this.deleteRequest(url, params).pipe((0, operators_1.map)((obj) => obj.client_dual_id));
    }
    /**
     * 提取理财收益
     * @param params
     */
    collectProfit(params) {
        const url = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().FM_HOST + "/dual/collect/";
        return this.postRequest(url, params).pipe((0, operators_1.map)((obj) => obj.client_dual_id));
    }
    /**
     * 请求双币理财的折线图
     * @param params
     */
    queryDualPolyline(params) {
        const url = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().FM_HOST + "/dual/polyline/";
        return this.getRequest(url, params).pipe((0, operators_1.map)((data) => {
            return data.history_price;
        }));
    }
    // 请求双币产品列表
    queryDualShowGroup() {
        const url = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().FM_HOST + "/dual/show/group/";
        return this.getRequest(url).pipe((0, operators_1.map)((data) => {
            if (Array.isArray(data.list)) {
                return data.list;
            }
            return [];
        }));
    }
    /**
     * 已申购历史列表
     * @param param
     */
    queryInvestRecordsV2History(param) {
        const url = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().FM_HOST + "/dual/invest/paids/";
        return this.postRequest(url, param).pipe((0, operators_1.map)((a) => {
            return {
                has_more: a.has_more,
                next_token: a.next_token,
                records: a.records.map((b) => {
                    return this.parseDualOrder(b);
                }),
            };
        }));
    }
    // 请求300%年化产品列表
    queryUltraHighAPRProducts() {
        const url = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().FM_HOST + "/dual/activity/first_pro_list/";
        return this.getRequest(url).pipe((0, operators_1.map)((data) => {
            return this.filterProducts(data);
        }));
    }
    ///==> 体验金相关
    /**
     * 活动接口 - 获取用户当前适合的活动名称
     */
    queryCurrentActivityName(activity_type, region) {
        const url = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().FM_HOST + "/dual/activity/name/";
        return this.getRequest(url, {
            activity_type: activity_type,
            region: region,
        });
    }
    /**
     * 活动接口-获取用户活动
     */
    queryActivity(activity_name) {
        const url = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().FM_HOST + "/dual/activity/";
        return this.getRequest(url, { activity_name }).pipe((0, operators_1.map)((data) => {
            data.activity_name = activity_name;
            return data;
        }));
    }
    /**
     * 活动接口-获取体验金虚拟产品列表
     */
    queryVirtualProducts(param) {
        const url = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().FM_HOST + "/dual/activity/virtual_products/";
        return this.getRequest(url, param).pipe((0, operators_1.map)((data) => {
            return this.filterProducts(data);
        }));
    }
    joinActivityBonus(type) {
        const url = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().FM_HOST + "/dual/activity/bonus_join/";
        return this.postRequest(url, { join_activity: type });
    }
    /**
     * 活动接口-申购活动
     */
    investActivity(activity_id, activity_name, product_id, base_profit, profit_cos_ratio, invest_amount, escape_history, // 用于测试, 跳过已经开过单的错误直接开单, 只在测试环境有效.
    is_virtual_pro) {
        const url = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().FM_HOST + "/dual/activity/invest/";
        return this.postRequest(url, {
            activity_id: activity_id,
            activity_name: activity_name,
            product_id: product_id,
            base_profit: base_profit,
            profit_cos_ratio: profit_cos_ratio,
            escape_history: escape_history,
            invest_amount: invest_amount,
            is_virtual_pro: is_virtual_pro,
        });
    }
    /**
     * 活动接口-领取活动收益
     * 结束活动, 领取收益
     */
    endActivity(activity_id, activity_type, client_dual_id) {
        const url = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().FM_HOST + "/dual/activity/apply/";
        return this.postRequest(url, {
            activity_id: activity_id,
            activity_type: activity_type,
            client_dual_id: client_dual_id,
        });
    }
    /**
     * 活动接口: 历史订单
     */
    queryActivityRecordsHistory(limit, page_token) {
        const url = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().FM_HOST + "/dual/activity/paids/";
        return this.getRequest(url, {
            limit: limit,
            page_token: page_token,
        });
    }
    /**
     * 活动接口-获取用户奖励金额
     */
    queryTurialFundShareInfo() {
        const url = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().FM_HOST + "/dual/activity/user_bonus/";
        return this.getRequest(url);
    }
    /**
     * 活动接口-获取用户邀请数据详情
     */
    queryTurialFundInviteDetailList(pageToken) {
        const url = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().FM_HOST + "/dual/activity/invite_detail/";
        return this.getRequest(url, pageToken
            ? {
                page_token: pageToken,
            }
            : undefined);
    }
    /**
     * 查询-双币理财申购列表
     */
    queryDaulStructuredRecords(param) {
        const url = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().FM_HOST + "/structured/invest/records/";
        return this.postRequest(url, param).pipe((0, operators_1.map)((a) => {
            return {
                has_more: a.has_more,
                next_token: a.next_token,
                records: a.records.map((b) => {
                    return this.parseStructureDualOrder(b);
                }),
            };
        }));
    }
    /**
     * 查询-双币理财申购历史列表
     */
    queryDaulStructureRecordsHistory(param) {
        const url = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().FM_HOST + "/structured/invest/paids/";
        return this.postRequest(url, param).pipe((0, operators_1.map)((a) => {
            return {
                has_more: a.has_more,
                next_token: a.next_token,
                records: a.records.map((b) => {
                    return this.parseStructureDualOrder(b);
                }),
            };
        }));
    }
}
const DCMV2 = (apiKey) => {
    return new DCMV2Class(apiKey);
};
exports.DCMV2 = DCMV2;
